export const moduleName = 'payments';

export default {
  START_TRIAL_FAILURE: `${moduleName}/START_TRIAL_FAILURE`,
  START_TRIAL_REQUEST: `${moduleName}/START_TRIAL_REQUEST`,
  START_TRIAL_SUCCESS: `${moduleName}/START_TRIAL_SUCCESS`,
};
